export default {
  general: {
    employee: "Mitarbeiter",
    unknown_user: "Unbekannter Benutzer",
    no_employees_found: "Keine Mitarbeiter gefunden",
  },
  overview: {
    title: "Mitarbeiter Übersicht",
    archive_title: "Ausgeschiedene Mitarbeiter",
    // Das Archiv der Mitarbeiter heißt nach dem, was es für eine Person bedeutet.
    archive_show: "Ausgeschiedene anzeigen",
    archive_hint:
      "Können sich nicht anmelden und erscheinen in keiner Liste. Öffne eine Person, um sie wieder zu aktivieren.",
    subtitle: "Auflistung aller Mitarbeiter.",
    actions: {
      create_new: "Neuen Mitarbeiter erstellen",
    },
    search: {
      placeholder: "bspw. E-Mail, Nachname, Vorname, etc.",
    },
    filter: {
      label: "Benutzertyp",
      all: "Alle",
      login: "Login-Benutzer",
      data: "Verwaltungsbenutzer",
    },
    table: {
      headers: {
        id: "ID",
        name: "Mitarbeiter",
        lastname: "Nachname",
        firstname: "Vorname",
        email: "E-Mail",
        phone: "Telefon",
        createdAt: "Erstellt am",
      },
      no_email_set: "-Keine E-Mail-",
      no_position_set: "-Keine Position-",
      login: {
        none: "Kein Zugang",
        disabled: "Zugang gesperrt",
        active: "Hat Zugang",
      },
    },
  },
  create: {
    title: "Mitarbeiter anlegen",
    subtitle: "Neuen Mitarbeiter anlegen.",
    duplicate_dialog: {
      title: "Mitarbeiter existiert bereits",
      text: "Ein Mitarbeiter mit dem Namen <strong>{name}</strong> existiert bereits. Handelt es sich um eine andere Person?",
      existing_label: "Bestehende Mitarbeiter mit diesem Namen:",
      confirm: "Ja, trotzdem anlegen",
      cancel: "Abbrechen",
    },
    dialog_title: "Neuer Benutzer",
    dialog_subtitle: "Benutzertyp auswählen",
    auth_user: {
      title: "Login-Benutzer",
      text: "Kann sich anmelden und die Webplattform nutzen.",
    },
    data_user: {
      title: "Verwaltungsbenutzer",
      text: "Kann sich <strong>nicht</strong> anmelden. Nur für die interne Verwaltung.",
    },
    seat_hint:
      "Nur Login-Benutzer belegen einen kostenpflichtigen Benutzerplatz. Verwaltungsbenutzer können Sie unbegrenzt anlegen.",
  },
  detail: {
    title: "Mitarbeiter Details",
    user_type_tooltip: {
      web: "Kann sich anmelden",
      data: "Nur interne Verwaltung",
    },
    tabs: {
      general: "Allgemein",
      company: "Unternehmens-relevant",
      system: "System spezifisch",
      files: "Dateiablage",
      extended: "Erweitert",
      activity: "Protokoll",
    },
    actions: {
      actions: "Aktionen",
      times: "Zeiten prüfen",
      planning: "In Personalplanung anzeigen",
      add_custom_field: "Benutzerdefiniertes Feld Hinzufügen",
      upload_avatar: "Bild hochladen",
      change_avatar: "Bild ändern",
      remove_avatar: "Entfernen",
      initial_avatar: "Um ein Profilbild setzen zu können, musst du zuerst den Benutzer erstellen.",
      update: "Speichern",
      // Ausgeschieden = archiviert (docs/archiving.md): kein Login, kein Platz, raus aus allen Auswahllisten.
      archive: {
        // „Entfernen“: wer schon etwas erfasst hat, wird als ausgeschieden markiert, sonst gelöscht.
        text: "Die Person kann sich nicht mehr anmelden, belegt keinen Platz mehr und erscheint in keiner Liste, Auswahl und Planung, auch nicht in „Zeiten prüfen“: gib ihre letzten Zeiten vorher frei. Hat sie schon etwas erfasst, gilt sie als ausgeschieden: Berichte, Zeiten und Abwesenheiten bleiben erhalten, und du kannst sie jederzeit wieder aktivieren. Sonst wird sie gelöscht.",
        restore: "Wieder aktivieren",
        hint: "Ausgeschieden: kann sich nicht anmelden und belegt keinen Platz.",
      },
      reset_password: {
        reset_password_via_mail: "Password per Mail zurücksetzen",
        reset_password_manually: "Password manuell zurücksetzen",
        modal: {
          title: "Passwort zurücksetzen",
          text_mail:
            "Bist du dir sicher, dass du dem Benutzer eine E-Mail schicken willst, mit dem dieser sein Passwort neu setzen kann?",
          text_manual: "Bist du sicher dass du das aktuelle Passwort des Benutzers überschreiben willst?",
          password_input: "Neues Passwort",
          password_input_verify: "Passwort erneut eingeben",
          password_verify_invalid: "Passwörter stimmen nicht überein",
          agree: "Zustimmen",
          disagree: "Abbrechen",
        },
      },
      convert: {
        convert_to_login: "In Login-Benutzer umwandeln",
        modal: {
          title: "In Login-Benutzer umwandeln",
          subtitle:
            "Der Mitarbeiter erhält seine Zugangsdaten per E-Mail und kann sich anschließend an der Webplattform anmelden.",
          seat_hint: "Der Mitarbeiter belegt danach einen kostenpflichtigen Benutzerplatz.",
        },
      },
    },
    form: {
      personnel_number: "Personalnummer",
      personnel_type: "Personal Typ",
      personnel_kind: "Personal Art",
      entry_date: "Eintrittsdatum",
      exit_date: "Austrittsdatum",
      wage_type: "Lohnart",
      // Der Betrag selbst. Das Formular beschriftet ihn mit der gewählten Lohnart, das Protokoll
      // braucht ein Wort, das zu jeder passt.
      wage_value: "Lohn",
      HOURLY_WAGE: "Stundenlohn", // Name must be equal to property name
      MONTHLY_WAGE: "Monatslohn", // Name must be equal to property name
      YEARLY_WAGE: "Jahreslohn", // Name must be equal to property name
      holiday_days: "Urlaubstage Gesamt",
      empowerment: "Befähigung",
      employer_contribution: "Arbeitgeberanteil",
      // Hinter dem ⓘ im Feld. {percent} ist der Standard aus den Einstellungen, der bei leerem Feld gilt.
      employer_contribution_hint:
        "Aufschlag auf die Personalkosten (Sozialversicherung). Leer lassen, dann gilt der Standard aus den Einstellungen: {percent} %.",
      social_insurance_number: "Sozialversicherungsnummer",
      insurance: "Versicherung",
      birthday_date: "Geburtsdatum",
      first_name: "Vorname",
      last_name: "Nachname",
      telephone_number: "Telefonnummer",
      profile_picture: "Profilbild",
      personal_data: "Persönliche Daten",
      address: "Adresse",
      state: "Bundesland",
      street: "Straße",
      location: "Ort",
      country: "Land",
      main_language: "Hauptsprache",
      main_language_hint:
        "Die Lewara-App fragt beim ersten Öffnen nach ihrer Sprache. Ist dort eine andere gewählt, bietet sie diese nach der Anmeldung einmal an. Leer: die Sprache des Telefons.",
      postcode: "PLZ",
      house_number: "Hausnummer",
      email: "E-Mail",
      position: "Mitarbeiterrolle",
      custom_fields: {
        text: "Benutzerdefinierte Felder",
        title: "Neues Benutzerdefiniertes Feld erstellen",
        subtitle: "Sobald Sie ein neues Feld anlegen, wird dieses für alle Mitarbeiter erstellt.",
        submit: "Erstellen",
        cancel: "Abbrechen",
        label_field: "Feldname",
        label_placeholder: "Kurzbeschreibung",
      },
      roles: {
        title: "Rollen-Zuweisung",
        role: "Rolle",
        active: "Zugeordnete Rollen",
        inactive: "Verfügbare Rollen",
        empty_active: "Noch keine Rollen zugewiesen",
        empty_inactive: "Alle Rollen zugewiesen",
      },
    },
  },
  position: {
    no_results: 'Keine Ergebnisse gefunden zu "<strong>{value}</strong>"',
    overview: {
      title: "Alle Personalrollen",
      subtitle: "Alle Personalrollen sind hier aufgelistet",
      empty_items: "Keine Rollen vorhanden",
      add_item: "Fügen Sie eine neue Rolle hinzu",
    },
    configure: "Verwalten",
  },
}
